import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import './authLayout.scss';
import Footer from 'components/Common/Footer/Footer';
import useAuthStore from 'store/auth';
import { USER_TYPES } from 'constants/index';

const AuthLayout: React.FC = () => {
	const { token, user }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	if (token) {
		return (
			<Navigate
				// to={`${user?.userType === USER_TYPES?.COMPANY || user?.preference ? '/social-feed-posts' : 'seeker/job-preference'}`}
				to={`${'/social-feed-posts'}`}
			/>
		);
	}
	return (
		<>
			<Outlet />
			<Footer />
		</>
	);
};

export default AuthLayout;
